'use strict';

var React = require('react'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    PlayerStore = require('../stores/PlayerStore'),
    PlayerActionCreators = require('../actions/PlayerActionCreators'),
    AudioCover = require('../molecules/AudioCover'),
    AudioContainer = require('./AudioContainer'),
    DefaultAudioImage = require('../constants/DefaultAudioImage'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    MediaTypes = require('../constants/MediaTypes'),
    { PropTypes } = React;

var AudioTrack = React.createClass({
  mixins: [createStoreMixin(PlayerStore), PureRenderMixin],

  propTypes: {
    uuid: PropTypes.string.isRequired,
    source: PropTypes.string,
    background: PropTypes.object,
    streamUrl: PropTypes.string,
    url: PropTypes.string.isRequired,
    stamp: PropTypes.shape({
      id: PropTypes.number
    }).isRequired
  },

  getStateFromStores() {
    var mediaId = this.props.uuid;

    return {
      isPlaying: PlayerStore.isPlaying(mediaId),
      isPaused: PlayerStore.isPaused(mediaId),
      currentTime: PlayerStore.getCurrentTime(mediaId),
      artwork: PlayerStore.getArtwork(mediaId)
    };
  },

  componentWillMount() {
    PlayerActionCreators.registerAudio(this.props.uuid, {
      mediaType: MediaTypes.AUDIO_PLAYLIST,
      background: this.props.background,
      tracks: [this.props],
      trackIndex: 0,
      stampId: this.props.stamp.id
    });
  },

  componentWillUnmount() {
    PlayerActionCreators.unregisterAudio(this.props.uuid);
  },

  getArtwork() {
    return this.state.artwork || DefaultAudioImage;
  },

  getBackground() {
    return this.props.background || DefaultAudioImage;
  },

  renderCover() {
    var { isPlaying, currentTime, isPaused } = this.state,
        { url, duration } = this.props;

    return (
      <AudioCover uuid={this.props.uuid}
                  linkUrl={url}
                  artwork={this.getArtwork()}
                  colors={this.getBackground().colors}
                  duration={duration}
                  currentTime={currentTime}
                  isPlaying={isPlaying}
                  isPaused={isPaused}
                  onPlay={this.togglePause}
                  onPause={this.togglePause}
                  onBackward={this.handleBackward}
                  onForward={this.handleForward}
                  context='AudioTrack' />
    );
  },

  render() {
    return (
      <AudioContainer title={this.props.title}
                      username={this.props.username}
                      duration={this.props.duration}
                      background={this.getBackground()}
                      url={this.props.url}
                      cover={this.renderCover()} />
    );
  },

  togglePause() {
    var isPlaying = this.state.isPlaying,
        mediaId = this.props.uuid;

    if (isPlaying) {
      PlayerActionCreators.pause(mediaId);
    } else {
      PlayerActionCreators.play(mediaId);
    }
  },

  handleBackward() {
    PlayerActionCreators.playPrevious(this.props.uuid);
  },

  handleForward() {
    PlayerActionCreators.playNext(this.props.uuid);
  }
});

module.exports = AudioTrack;



/** WEBPACK FOOTER **
 ** ./stamp/AudioTrack.jsx
 **/